import React, { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
// Components
import ClientSlider from "../elements/ClientSlider";
import ServiceBox from "../elements/ServiceBox";
import FullButton from "../Buttons/FullButton";
// Assets
import AddImage1 from "../assets/img/add/merchant1.png";
import AddImage2 from "../assets/img/add/app.png";
import AddImage3 from "../assets/img/logo-main.png";
import AddImage4 from "../assets/img/add/app2.png";

// import HentianKomunitiApp from "../Apk/test/app.apk"

export default function Services() {
  const navigate = useNavigate();
  const [showDownload, setShowDownload] = useState(false);
  const goToRegister = () => {
    navigate("/signup");
  };

  const downloadApk = () => {
    setShowDownload(true);
    // const downloadLink = document.createElement('a');
    // downloadLink.href = HentianKomunitiApp // Replace with the path to your file
    // downloadLink.setAttribute('download', 'Hentian Komuniti.apk'); // Replace with the desired file name

    // // Append the link to the body
    // document.body.appendChild(downloadLink);

    // // Trigger a click on the link
    // downloadLink.click();

    // // Clean up: remove the link from the DOM
    // document.body.removeChild(downloadLink);
  };
  const handleClose = () => setShowDownload(false);
  return (
    <Wrapper id="services">
      <Modal show={showDownload} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Download Hentian Komuniti Mobile App</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Go to the below link</p>
          <p>
            <a id="custom-download-link" href="https://test">https://test</a>
          </p>
          {/* You can customize this message */}
        </Modal.Body>
        <Modal.Footer>
          <Button id="custom-button" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="lightBg" style={{ padding: "50px 0" }}>
        <div className="container">
          <ClientSlider />
        </div>
      </div>
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Our Awesome Services</h1>
            <p className="font13">
              Hentian Komuniti, owned by a local business, sparks this community
              spirit. Being part of it gives a deep sense of belonging and
              identity. Shared ownership and local involvement gradually create
              a strong, interconnected community.
            </p>
          </HeaderInfo>
          <ServiceBoxRow className="flex">
            <ServiceBoxWrapper>
              <ServiceBox
                icon="latte1"
                title="Benefit of the app"
                subtitle="Community participation
                builds social networks.
                The app offers shop discounts
                for loyal customers.
                Reducing traffic congestion and
                promoting walkability lead to a
                happier community.
                Foster shared values and 
                contribute to community
                development."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="latte2"
                title="Benefit of Hentian Komuniti"
                subtitle="The popularity of the
                business and the
                widespread application of
                the MADANI principle can
                encourage more non income-based use of the
                building, increase the
                number of visitors, and
                provide the building with
                a variety of uses."
              />
            </ServiceBoxWrapper>
            <ServiceBoxWrapper>
              <ServiceBox
                icon="latte3"
                title="Impact"
                subtitle="Provide facilities to
                assist pedestrian (toilet,
                info, hospitality).
                Encourage walking.
                Increase public-private
                partnership.
                Enhance community 
                participation."
              />
            </ServiceBoxWrapper>
          </ServiceBoxRow>
        </div>
        <div className="lightBg">
          <div className="container">
            <Advertising className="flexSpaceCenter">
              <AddLeft>
                <h4 className="font15 semiBold">
                  A few words about Hentian Komuniti
                </h4>
                <h2 className="font40 extraBold">The application we provide</h2>
                <h6 className="mt-3 font15 semiBold">
                  Merchant: Web Application for managing the facility.{" "}
                </h6>
                <h6 className="mt-3 font15 semiBold">
                  User: Mobile Application to use the facility provided.{" "}
                </h6>
                <ButtonsRow
                  className="flexNullCenter"
                  style={{ margin: "30px 0" }}
                >
                  <div style={{ width: "250px" }}>
                    <FullButton
                      title="Get Started as Merchant"
                      action={goToRegister}
                    />
                  </div>
                  <div style={{ width: "200px", marginLeft: "15px" }}>
                    <FullButton
                      title="Get Started as User"
                      action={downloadApk}
                      border
                    />
                  </div>
                </ButtonsRow>
              </AddLeft>
              <AddRight>
                <AddRightInner>
                  <div className="flexNullCenter">
                    <AddImgWrapp1 className="flexCenter">
                      <img className="add-image" src={AddImage1} alt="app" />
                    </AddImgWrapp1>
                    <AddImgWrapp2>
                      <img src={AddImage2} alt="app" />
                    </AddImgWrapp2>
                  </div>
                  <div className="flexNullCenter">
                    <AddImgWrapp3>
                      <img src={AddImage3} alt="app" />
                    </AddImgWrapp3>
                    <AddImgWrapp4>
                      <img src={AddImage4} alt="app" />
                    </AddImgWrapp4>
                  </div>
                </AddRightInner>
              </AddRight>
            </Advertising>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const ServiceBoxRow = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const ServiceBoxWrapper = styled.div`
  width: 33%;
  margin-right: 5%;
  margin-bottom: 5%;
  padding: 10px 0;
  @media (max-width: 860px) {
    width: 100%;
    text-align: center;
    padding: 40px 0;
    margin-bottom: 0%;
  }
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  margin: 80px 0;
  padding: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 100px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  position: absolute;
  top: -70px;
  right: 0;
  @media (max-width: 860px) {
    width: 80%;
    position: relative;
    order: 1;
    top: -40px;
  }
`;
const AddRightInner = styled.div`
  width: 100%;
`;
const AddImgWrapp1 = styled.div`
  width: 48%;
  margin: 0 6% 10px 6%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp2 = styled.div`
  width: 30%;
  margin: 0 5% 10px 5%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp3 = styled.div`
  width: 20%;
  margin-left: 40%;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
const AddImgWrapp4 = styled.div`
  width: 30%;
  margin: 0 5%auto;
  img {
    width: 100%;
    height: auto;
    border-radius: 1rem;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0 2px 15px rgba(0, 0, 0, 0.3);
  }
`;
